import moment from "moment";

type ObjectTypeWithStringValue = {
  [key: string]: string;
};

export const baseURL = process.env.REACT_APP_BACKEND_URL;

export const colorsArray: string[] = [
  "#07a7e3", // Bright blue
  "#e09e2d", // Gold
  "#238167", // Forest green
  "#ff2211", // Vivid red
  "#3bb639", // Lime green
  "#1E1E1E", // Near black
  "#0d5a64", // Teal
  "#8a2be2", // Blue violet (new)
  "#ff69b4", // Hot pink (new)
  "#00fa9a", // Medium spring green (new)
  "#ff8c00", // Dark orange (new)
  "#9370db", // Medium purple (new)
];

export const userRoleObj: { [key: string]: string } = {
  user: "USER",
  admin: "ADMIN",
  manager: "MANAGER",
};

export const licenseValidityStatus: { valid: string; invalid: string } = {
  valid: "Valid",
  invalid: "Invalid",
};

export const endPoints: ObjectTypeWithStringValue = {
  leadEndPoint: "/api-lead/lead",
  rawLeadEndPoint: "/api-raw-lead/raw-lead",
  polishLeadEndPoint: "/api-polish-lead/polish-lead",
  leadTaskEndPoint: "/api-task/task",
  leadCommentEndPoint: "/api-comment/comment",
  contactEndPoint: "/api-contact/contact",
  projectEndPoint: "/api-project/project",
  sourceEndPoint: "/api-source/source",
  userEndPoint: "/api-user/user",
  leadActivityEndPoint: "/api-activity/activity",
  rawLeadTableStateEndPoint: "/api-raw-lead-table-state/raw-lead-table-state",
  polishLeadTableStateEndPoint:
    "/api-polished-lead-table-state/polished-lead-table-state",
  taskTableStateEndPoint: "/api-task-table-state/task-table-state",
  callRecordTableStateEndPoint:
    "/api-call-record-table-state/call-record-table-state",
  callRecordEndPoint: "/api-call/call-record",
  customerEndPoint: "/api-customer/customer",
  exportLeadTableStateEndPoint:
    "/api-export-lead-table-state/export-lead-table-state",
  dashboardTaskStatsEndPoint: "/api-task-stats/task-stats",
  dashboardLeadStatsEndPoint: "/api-lead-stats/lead-stats",
  userDashboardStateEndPoint: "/api-dashboard/user-dashboard",
  userWidgetEndPoint: "/api-widget/widget",
  companyEndPoint: "/api-company/company",
  sharedLeadEndpoint: "/api-shared-lead/shared-lead",
  tokenEndPoint: "/api-token/token",
  inventoryEndPoint: "/api-property-unit/property-unit",
  propertyUnitTableStatEndPoint:
    "/api-property-unit-table-state/property-unit-table-state",
  tokenTableStateEndPoint: "/api-token-table-state/token-table-state",
  tokenActivityEndPoint: "/api-token-activity/activity",
  propertyActivityEndpoint: "/api-property-activity/activity",
  staffTargetTableStateEndPoint:
    "/api-task-target-table-state/task-target-table-state",
  staffTargetEndPoint: "/api-task-target/task-target",
  staffTargetDetailEndPoint: "/api-task-target-detail/task-target",
  staffTargetActivityEndPoint: "/api-task-target-activity/activity",
  tokenCommentEndPoint: "/api-token-comment/comment",
  individualPropertyTableStateEndPoint:
    "/api-individual-property-table-state/table-state",
  individualPropertyEndPoint: "/api-individual-property/property",
  individualPropertyActivityEndPoint:
    "/api-individual-property-activity/activity",
  taskActivityEndPoint: "/api-task-activity/activity",
  projectBlockEndPoint: "/api-block/block",
  projectPhaseEndPoint: "/api-phase/phase",
  teamEndPoint: "/api-team/team",
  teamActivityEndPoint: "/api-team-activity/activity",
  projectAssignmentEndPoint: "/api-project-assignment/project",
  userPermissionEndPoint: "/api-permission/user-permission",
  passwordChangeEndPoint: "/api-user/user/change-password",
  userSettingEndPoint: "/api-user-setting/user-settings",
  primaryDashboardEndPoint: "/api-primary-dashboard/dashboard",
  dashboardCardsEndPoint: "/api-dashboard-widget/widget",
  allUserEndPoint: "/api-username/user", //to get all users for share lead
  allActivityEndPoint: "/api-all-activity/activity",
  userProfileEndPoint: "/api-userprofile/user",
  userProjectAssignmentEndPoint: "/api-user-project-assign/user",
  teamProjectAssignmentEndPoint: "/api-team-project-assign/team",
  projectDocumentEndPoint: "/api-project-document/project",
  salesEndPoint: "/api-sale/sales",
  salesTableStateEndPoint: "/api-sale-table-state/table-state",
  projectActivityEndPoint: "/api-project-activity/activity",
};

export const leadTypes: ObjectTypeWithStringValue = {
  rawLead: "raw-lead",
  polishedLead: "polished-lead",
  common: "common",
  adminLead: "admin-lead",
  pendingLead: "pending-lead",
};

export const inventoryTypes: ObjectTypeWithStringValue = {
  projectInventory: "project-inventory",
  nonProjectInventory: "non-project-inventory",
};

export const leadsActionTypes: ObjectTypeWithStringValue = {
  addRawLeadsFulfilled: "leads/addRawLeads/fulfilled",
  addPolishedLeadFulfilled: "leads/addPolishedLeads/fulfilled",
  deleteRawLeadsFulfilled: "leads/deleteRawLead/fulfilled",
  deletePolishedLeadsFulfilled: "leads/deletePolishedLead/fulfilled",
  updateLeadFulfilled: "leads/updateLead/fulfilled",
  updateRawLeadsFulfilled: "leads/updateLead/fulfilled",
  updatePolishedLeadsFulfilled: "leads/updatePolishLead/fulfilled",
};

export const taskActionTypes: ObjectTypeWithStringValue = {
  deleteTaskFulfilled: "tasks/deleteTask/fulfilled",
  addNewTaskFulfilled: "tasks/addNewTask/fulfilled",
  updateTaskFulfilled: "tasks/updateTask/fulfilled",
};

export const commentActionTypes: ObjectTypeWithStringValue = {
  addNewCommentFulfilled: "comments/addNewComment/fulfilled",
  addNewCommentInTokenFulfilled: "comments/addNewCommentInToken/fulfilled",
};

export const callRecordActionTypes: ObjectTypeWithStringValue = {
  deleteCallRecordFulfilled: "callRecord/deleteCallRecord/fulfilled",
};

export const saleActionTypes: ObjectTypeWithStringValue = {
  deleteSaleFulfilled: "sales/deleteSale/fulfilled",
};

export const allActivityActionTypes: ObjectTypeWithStringValue = {
  deleteActivityFulfilled: "activities/deleteActivity/fulfilled",
};

export const tableStateActionTypes: ObjectTypeWithStringValue = {
  updateRawLeadTableStateFulfilled:
    "tableStates/updateRawLeadTableState/fulfilled",
  updatePolishLeadTableStateFulfilled:
    "tableStates/updatePolishLeadTableState/fulfilled",
  updateAdminLeadTableStateFulfilled:
    "tableStates/updateAdminLeadTableState/fulfilled",
  updateTaskTableStateFulfilled: "tableStates/updateTaskTableState/fulfilled",
  updateCallRecordTableStateFulfilled:
    "tableStates/updateCallRecordTableState/fulfilled",
  updatePropertyUnitStateFulfilled:
    "tableStates/updateAPropertyTableState/fulfilled",
  updateIndividualPropertyUnitStateFulfilled:
    "tableStates/updateIndividualPropertyUnitTableState/fulfilled",

  updateTokenStateFulfilled: "tableStates/updateTokenTableState/fulfilled",
  updateStaffTargetStateFulfilled:
    "tableStates/updateStaffTargetTableState/fulfilled",
  updateSalesStateFulfilled: "tableStates/updateSalesTableState/fulfilled",
};

export const customerActionTypes: ObjectTypeWithStringValue = {
  updateCustomerFulfilled: "customer/updateCustomerData/fulfilled",
};

export const projectActionTypes: ObjectTypeWithStringValue = {
  addProjectFulfilled: "projects/addProjects/fulfilled",
  deleteProjectFulfilled: "projects/deleteProject/fulfilled",
  updateProjectFulfilled: "projects/updateProject/fulfilled",
};

export const projectAssignmentActionTypes: ObjectTypeWithStringValue = {
  updateProjectAssignmentInBulkFulfilled:
    "projectAssignments/updateProjectAssignmentInBulk/fulfilled",
  updateProjectAssignmentFulfilled:
    "projectAssignments/updateProjectAssignment/fulfilled",
  updateUserProjectAssignmentFulfilled:
    "projectAssignments/updateAssignProjectsToUser/fulfilled",
  updateTeamProjectAssignmentFulfilled:
    "projectAssignments/updateAssignProjectsToTeam/fulfilled",
};

export const teamActionTypes: ObjectTypeWithStringValue = {
  addTeamFulfilled: "teams/addNewTeam/fulfilled",
  deleteTeamFulfilled: "teams/deleteTeam/fulfilled",
  updateTeamFulfilled: "teams/updateTeam/fulfilled",
};

export const sourceActionTypes: ObjectTypeWithStringValue = {
  addSourceFulfilled: "source/addSource/fulfilled",
  deleteSourceFulfilled: "source/deleteSource/fulfilled",
  updateSourceFulfilled: "source/updateSource/fulfilled",
};

export const userActionTypes: ObjectTypeWithStringValue = {
  deleteUserFulfilled: "users/deleteUser/fulfilled",
  updateUserFulfilled: "users/updateUser/fulfilled",
  addNewUserFulfilled: "users/addNewUser/fulfilled",
  updatePasswordFulfilled: "users/updatePassword/fulfilled",
  updateUserProfileFullfilled: "users/updateUserProfile/fulfilled",
};

export const adminLeadsActionTypes: ObjectTypeWithStringValue = {
  deleteAdminLeadFulfilled: "leads/deleteAdminLeadsBulk/fulfilled",
  addAdminLeadFulfilled: "leads/addAdminLeadsBulk/fulfilled",
  updateAdminLeadFulfilled: "leads/updateAdminLeadsBulk/fulfilled",
  approveAdminLeadFulfilled: "leads/approveAdminLead/fulfilled",
};

export const adminPropertyActionTypes: ObjectTypeWithStringValue = {
  addAdminPropertyFulfilled: "properties/addAdminInventoryBulk/fulfilled",
  addAdminIndividualPropertyFulfilled:
    "properties/addAdminIndividualInventoryBulk/fulfilled",
};

export const userDashboardStateActionTypes: ObjectTypeWithStringValue = {
  updateUserDashboardStateFulfilled:
    "userDashboardState/updateUserDashboardState/fulfilled",
};

export const userWidgetsActionTypes: ObjectTypeWithStringValue = {
  addUserWidgetsFulfilled: "dashboardWidgets/addWidget/fulfilled",
  updateUserWidgetsFulfilled: "dashboardWidgets/updateWidget/fulfilled",
  deleteUserWidgetsFulfilled: "dashboardWidgets/deleteWidget/fulfilled",
};

export const contactsActionTypes: ObjectTypeWithStringValue = {
  deleteContactFulfilled: "contacts/deleteContact/fulfilled",
  addNewContactFulfilled: "contacts/addNewContact/fulfilled",
  updateContactFulfilled: "contacts/updateContact/fulfilled",
};

export const phaseActionTypes: ObjectTypeWithStringValue = {
  deletePhaseFulfilled: "phases/deleteProjectPhase/fulfilled",
  addNewPhaseFulfilled: "phases/addNewProjectPhase/fulfilled",
  updatePhaseFulfilled: "phases/updateProjectPhase/fulfilled",
};

export const blocksActionTypes: ObjectTypeWithStringValue = {
  deleteBlockFulfilled: "blocks/deleteProjectBlock/fulfilled",
  addNewBlockFulfilled: "blocks/addNewProjectBlock/fulfilled",
  updateBlockFulfilled: "blocks/updateProjectBlock/fulfilled",
};

export const tokensActionTypes: ObjectTypeWithStringValue = {
  deleteTokenFulfilled: "tokens/deleteToken/fulfilled",
  addNewTokenFulfilled: "tokens/addNewToken/fulfilled",
  updateTokenFulfilled: "tokens/updateToken/fulfilled",
};

export const inventoryActionTypes: ObjectTypeWithStringValue = {
  deleteInventoryFulfilled: "inventory/deleteInventory/fulfilled",
  addNewInventoryFulfilled: "inventory/addNewInventory/fulfilled",
  updateInventoryFulfilled: "inventory/updateInventory/fulfilled",
};

export const individualInventoryActionTypes: ObjectTypeWithStringValue = {
  deleteInventoryFulfilled: "inventory/deleteIndividualProperty/fulfilled",
  addNewInventoryFulfilled: "inventory/addNewIndividualInventory/fulfilled",
  updateInventoryFulfilled: "inventory/updateIndividualInventory/fulfilled",
};

export const staffTargetActionTypes: ObjectTypeWithStringValue = {
  deleteStaffTargetFulfilled: "staffTargets/deleteStaffTarget/fulfilled",
  addNewStaffTargetFulfilled: "staffTargets/addNewStaffTarget/fulfilled",
  updateStaffTargetFulfilled: "staffTargets/updateStaffTarget/fulfilled",
};

export const userPermissionActionTypes: ObjectTypeWithStringValue = {
  updateUserPermissionFulfilled: "permissions/updateUserPermission/fulfilled",
};

export const userSettingsActionTypes: ObjectTypeWithStringValue = {
  updateUserSettingsFulfilled: "settings/updateUserSettings/fulfilled",
};

export const primaryDashboardStateActionTypes: ObjectTypeWithStringValue = {
  updatePrimaryDashboardStateFulfilled:
    "primaryDashboardState/updateUserPrimaryDashboardState/fulfilled",
};

export const dashboardCardsActionTypes = {
  updateDashboardCardsFulfilled: "dashboardCards/updateCard/fulfilled",
  addDashboardCardsFulfilled: "dashboardCards/addCard/fulfilled",
  deleteDashboardCardFulfilled: "dashboardCards/deleteCard/fulfilled",
};

export const projectDocumentActionTypes = {
  addProjectDocumentFulfilled: "projectDocument/addProjectDocument/fulfilled",
  updateProjectDocumentFulfilled:
    "projectDocument/updateProjectDocument/fulfilled",
  deleteProjectDocumentFulfilled:
    "projectDocument/deleteProjectDocument/fulfilled",
};

export const allLeadsPageProp: { [key: string]: any } = {
  showAddPopupBtn: true,
  type: "raw-lead",
  showFilters: [
    "project",
    "source",
    "lead_status",
    "lead_priority",
    "date_open",
    "date_closed",
    "followup_date",
    "phone_number",
    "customer",
    "assigned_user",
    "customer_visited",
  ],
};

export const columnsKeys: { [key: string]: any } = {
  phoneNumber: "phone_number",
  customer: "customer",
  action: "action",
  agent: "user",
  timestamp: "timestamp",
  activity: "activity",
  assignedUser: "assigned_user",
  lead: "lead",
  selection: "select",
  recording: "recording",
  // receiptId: "receipt_id",
  propertyNumber: "property_number",
  propertyNo: "property_no",
  propertyUnit: "property_unit",
  progress: "progress",
  task: "task",
  description: "description",
  tokenNo: "token_no",
  size: "size",
  projectName: "project_name",
  projectId: "project_id",
  blocks: "blocks",
  available: "available",
  sold: "sold",
  booked: "booked",
  notAvailable: "not_available",
  teamName: "team_name",
  projectAssignee: "assignee",
  username: "username",
  activitySource: "activity_source",
  userProjects: "userProjects",
  teamProjects: "teamProjects",
  activityUser: "activity_user",
  activityLead: "activity_lead",
  document: "document",
  project: "project",
  token: "token",
  salesCustomer: "sales_customer",
  salesToken: "sales_token",
  leadQualifiedCall: "lead_qualified_call",
};

export const allPolishedLeadsPageProp: { [key: string]: any } = {
  showAddPopupBtn: true,
  type: "polished-lead",
  showFilters: [
    "project",
    "source",
    "lead_status",
    "lead_priority",
    "date_open",
    "date_closed",
    "followup_date",
    "phone_number",
    "customer",
    "assigned_user",
    "customer_visited",
    "date_polish_lead",
  ],
};

export const otherLeadsPageProp: { [key: string]: any } = {
  showAddPopupBtn: false,
  type: "raw-lead",
  showFilters: [
    "project",
    "date_open",
    "date_closed",
    "followup_date",
    "assigned_user",
    "customer_visited",
  ],
};

export const otherPolishedLeadsPageProp: { [key: string]: any } = {
  showAddPopupBtn: false,
  type: "polished-lead",
  showFilters: [
    "project",
    "date_open",
    "date_closed",
    "followup_date",
    "assigned_user",
    "customer_visited",
    "date_polish_lead",
  ],
};

export const alltaskPageProp: { [key: string]: any } = {
  showAddPopupBtn: true,
  showFilters: [
    "task_status",
    "task_priority",
    "date_created",
    "date_closed",
    "project",
    "due_date",
    "assigned_user",
    "task",
  ],
};

export const otherTaskPageProp: { [key: string]: any } = {
  showAddPopupBtn: false,
  showFilters: [
    "project",
    "date_created",
    "date_closed",
    "due_date",
    "assigned_user",
    "task",
  ],
};

export const allTokenPageProp: { [key: string]: any } = {
  showAddPopupBtn: true,
  showFilters: [
    "receipt_id",
    "project",
    "lead",
    "property",
    "property_nature",
    "payment_plan",
    "status",
    "date_expiry",
    "date_created",
    "date_updated",
    "createdby_user",
    "updatedby_user",
    "customer_cnic",
  ],
};

export const otherTokenPageProp: { [key: string]: any } = {
  showAddPopupBtn: false,
  showFilters: [
    "receipt_id",
    "project",
    "lead",
    "property",
    "property_nature",
    "payment_plan",
    "date_expiry",
    "date_created",
    "date_updated",
    "createdby_user",
    "updatedby_user",
    "customer_cnic",
  ],
};

export const tableVariant: { [key: string]: string } = {
  tasks: "tasks",
  rawLead: "raw-lead",
  polishedLead: "polished-lead",
  project: "project",
  source: "source",
  users: "users",
  usersMainPage: "users-main-page",
  adminLead: "admin-lead",
  callRecord: "call-record",
  customerContact: "customer-contact",
  leadRequest: "lead-request",
  leadTasks: "lead-tasks",
  token: "token",
  inventory: "inventory",
  taskTarget: "staff-target",
  individualProperty: "individual_property",
  completedItems: "completed-items",
  projectPhase: "project-phase",
  phaseBlocks: "phase-blocks",
  teams: "teams",
  activity: "activity",
  teamMembers: "team-members",
  projectDocuments: "project-documents",
  sales: "sales",
};

export const leadStatusObj: { [key: string]: string } = {
  statusNew: "New",
  statusOpen: "Open",
  statusActive: "Active",
  statusClosedWon: "Deal Closed Won",
  statusClosedLost: "Deal Closed Lost",
  statusRecycled: "Recycled",
  statusDead: "Dead",
  tokenBooked: "Token Booked",
  tokenExtended: "Token Extended",
};

export const priorityObj: { [key: string]: string } = {
  priorityHigh: "High",
  priorityLow: "Low",
  priorityNormal: "Normal",
  priorityUrgent: "Urgent",
};

export const taskStatusObj: { [key: string]: string } = {
  taskStatusOpen: "Open",
  taskStatusClosed: "Closed",
  taskStatusPending: "Pending",
};

export const propertyStatusObj: { [key: string]: string } = {
  propertyAvailable: "Available",
  propertySold: "Sold",
  propertyBooked: "Booked",
  propertyNotAvailable: "Not Available",
};

export const tokenStatusObj: { [key: string]: string } = {
  tokenStatusWon: "Deal Won",
  tokenStatusLost: "Deal Lost",
  tokenStatusExpired: "Time Expired",
  tokenStatusExtended: "Time Extended",
  tokenStatusOpen: "Open",
};

export const leadStatus: string = "status";
export const leadPriority: string = "priority";
export const sharedLeads: string = "shared-leads";
export const teams: string = "teams";

export const taskStatus: string = "status";
export const taskPriority: string = "priority";
export const task: string = "task";
export const token: string = "token";
export const callRecord: string = "call-record";
export const sales: string = "sales";
export const propertyUnit: string = "property-unit";
export const individualPropertyUnit: string = "individual-property-unit";
export const staffTarget: string = "staff-target";

export const tokenStatusPath: string = "status";

export const propertyStatusPath: string = "status";

export const taskTargetStatusPath: string = "status";

type OptionsArrayTypes = ObjectTypeWithStringValue[];

export const leadStatusOptions: OptionsArrayTypes = [
  { value: "new", label: "New" },
  { value: "active", label: "Active" },
  { value: "recycled", label: "Recycled" },
  { value: "dead", label: "Dead" },
  { value: "deal closed won", label: "Deal Closed Won" },
  { value: "deal closed lost", label: "Deal Closed Lost" },
];

export const leadStatusExtraOptions: OptionsArrayTypes = [
  { value: "token booked", label: "Token Booked" },
  { value: "token extended", label: "Token Extended" },
];

export const priorityOptions: OptionsArrayTypes = [
  { value: "low", label: "Low" },
  { value: "normal", label: "Normal" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const tokenStatusOptions: OptionsArrayTypes = [
  { value: "dealWon", label: "Deal Won" },
  { value: "dealLost", label: "Deal Lost" },
  { value: "timeExpired", label: "Time Expired" },
  { value: "timeExtended", label: "Time Extended" },
  { value: "open", label: "Open" },
];

export const taskStatusOptions: OptionsArrayTypes = [
  { value: "open", label: "Open" },
  { value: "closed", label: "Closed" },
  { value: "pending", label: "Pending" },
];

export const propertyStatusOptions: OptionsArrayTypes = [
  { value: "available", label: "Available" },
  { value: "sold", label: "Sold" },
  { value: "booked", label: "Booked" },
  { value: "not available", label: "Not Available" },
];

// Admin Routes
export const adminOnlyRoutes = [
  "/source",
  "/project",
  "/users",
  "/import",
  "/export",
];

export const routeToHideFromUserRole = ["/lead-request"];
export const admin: string = "admin";
export const pending: string = "pending";

export const selectAll: string = "select-all";
export const unSelectAll: string = "unselect-all";

export const apiSuccess: string = "success";
export const apiFail: string = "fail";

export const customerNameLength: number = 30;
export const taskDescriptionLength: number = 150;
export const customerAddressLength: number = 300;

export const layout: { [key: string]: "one-column" | "two-column" } = {
  oneColumn: "one-column",
  twoColumn: "two-column",
};

export const buttonVariant: {
  [key: string]: "primary" | "secondary" | "theme";
} = {
  primary: "primary",
  secondary: "secondary",
  theme: "theme",
};

export const limitOptions: { [key: string]: string | number }[] = [
  { value: "limit-20", label: 20 },
  { value: "limit-40", label: 40 },
  { value: "limit-60", label: 60 },
  { value: "limit-80", label: 80 },
  { value: "limit-100", label: 100 },
];

export const propertyTypeOptionsObj: ObjectTypeWithStringValue = {
  plot: "Plot",
  house: "House",
  apartment: "Apartment",
  farmhouse: "Farm House",
  villa: "Villa",
  shop: "Shop",
  other: "Other",
};

export const targetTaskStatusOptionsObj: ObjectTypeWithStringValue = {
  statusInProgress: "In Progress",
  statusStopped: "Stopped",
  statusNotStarted: "Not Started",
  statusCompleted: "Completed",
};

export const tokenWarningText: string =
  "You can create a token only for leads that are New, Active, or Recycled.";
export const tokenWarningTextForBooked: string =
  "A token is already booked against this lead.";
export const shareLeadWarning: string =
  "You can't share this lead since it's already shared.";

export const targetTypeObj: ObjectTypeWithStringValue = {
  task: "Task",
  newLead: "New Lead",
  qualifiedCalls: "Qualified Calls",
  nonQualifiedCalls: "Non-Qualified Calls",
  rawToPolishedLead: "Raw-to-Polish Lead Conversion",
  salesTarget: "Sales Target",
};

export const isProjectPropertyParam: string = "isProjectProperty";

export const noProject: string = "No Project Associated";
export const noUser: string = "No User Associated";
export const noTeam: string = "No Team Associated";

export const propertyListingSale: string = "Sale";
export const propertyListingRent: string = "Rent";

export const activitySourceObj: { [key: string]: string } = {
  lead: "Lead",
  task: "Task",
  projectInventory: "Project Inventory",
  nonProjectInventory: "Non-Project Inventory",
  team: "Team",
  token: "Token",
  taskTarget: "Task Target",
  user: "User",
  project: "Project",
};

export const current: string = "Current";
export const expiring: string = "Expiring";
export const pending_Status: string = "Pending";
export const currentDate = moment(new Date()).format("YYYY-MM-DD");
export const yesterdayDate = moment().subtract(1, "day").format("YYYY-MM-DD");

export const customerVisitedOptions: OptionsArrayTypes = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const saleCardVariantOptions: OptionsArrayTypes = [
  { value: "sale_amount", label: "Sale Amount" },
  { value: "no_of_sales", label: "No of Sales" },
];

export const saleCardVariantObj: ObjectTypeWithStringValue = {
  saleAmount: "Sale Amount",
  noOfSales: "No of Sales",
};

export const VARIANTS = {
  DASHBOARD: "dashboard",
};
